import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import { getLoanSummaryRequest } from 'tio-data/requests/user';

export default class AuthenticatedPslfDashboardForgivenessEstimatorIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const userId = this.sessionContext.user.id;
    if (!userId) return undefined;
    const response = await this.store.request(getLoanSummaryRequest(userId));
    return response.content;
  }
}
